import type { InvoiceStatus } from '@/api/client'
import { cn } from '@/lib/cn'
import { useTranslation } from 'react-i18next'

// Zinc-tone mapping — progress from light (draft) to dark (paid) so the
// badge conveys invoice maturity at a glance without colour cues.
const STATUS_STYLES: Record<InvoiceStatus, string> = {
  draft: 'bg-muted text-muted-foreground',
  issued: 'bg-muted text-foreground',
  partial: 'bg-muted text-foreground',
  paid: 'bg-foreground text-background',
  overdue: 'bg-primary text-primary-foreground',
  voided: 'bg-muted text-muted-foreground line-through',
}

interface Props {
  status: InvoiceStatus
  size?: 'sm' | 'md'
  className?: string
}

export function InvoiceStatusBadge({ status, size = 'sm', className }: Props) {
  const { t } = useTranslation('finance')
  return (
    <span
      className={cn(
        'inline-flex items-center whitespace-nowrap rounded-full font-medium',
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm',
        STATUS_STYLES[status],
        className,
      )}
    >
      {t(`status.${status}`)}
    </span>
  )
}
